import { TrashIcon } from 'canoe';
import React from 'react';

import { useMutations, useSelection, useEditor } from 'craft/hooks';

import { MenuItem } from './MenuItem';
import { useOnCloseMenu } from './useOnCloseMenu';

export const Delete = () => {
  const { query } = useEditor();
  const { deleteNode } = useMutations();
  const { selection } = useSelection();
  const onCloseMenu = useOnCloseMenu();

  const onDelete = () => {
    if (selection.isEmpty || selection.hasRootNode) {
      return;
    }
    deleteNode(selection.all);
    onCloseMenu();
  };

  const isDisabled = selection.all.some((nodeId: string) => !query.node(nodeId).isDeletable());

  return (
    <MenuItem
      onClick={onDelete}
      enabled={!isDisabled}
      icon={<TrashIcon color={isDisabled ? 'OnyxGrayL20' : 'White'} />}
      shortcuts={['Delete']}
    >
      Delete
    </MenuItem>
  );
};
